import { AlgAttivazioniService } from "./../../../services/alg-attivazioni.service";
import {
  Attivazione,
  Status,
  NotorietaRadio
} from "./../../../models/attivazione";
import { Component, OnInit, Input } from "@angular/core";
import { FormGroup, FormControl, Validators } from "@angular/forms";
import { tap } from "rxjs/operators";

@Component({
  selector: "alg-attivazioni-step2",
  templateUrl: "./alg-attivazioni-step2.component.html",
  styleUrls: ["./alg-attivazioni-step2.component.scss"]
})
export class AlgAttivazioniStep2Component implements OnInit {
  @Input() firstForm: any;
  @Input() firstFormStatus: any;
  @Input() firstFormRadioValue: any;
  public attivazione: Attivazione;
  public stepForm: FormGroup;
  public cadRadioOptions = [
    {
      label: "In base a permesso di costruire o concessione edilizia",
      value: "cadRadio1"
    },
    {
      label: "Denuncia di inizio attività (D.I.A)",
      value: "cadRadio3"
    },
    {
      label: "In base ad autorizzazione",
      value: "cadRadio4"
    },
    {
      label: "Prima della data 30.01.1977",
      value: "cadRadio5"
    },
    {
      label: "Permesso in sanatoria o concessione in sanatoria",
      value: "cadRadio2"
    },
    {
      label:
        "Domanda di permesso in sanatoria o domanda di concessione in sanatoria",
      value: "cadRadio6"
    }
  ];
  public cadRadioValue = "";
  public isModalOpen = false;
  // veneto & gas
  public isVeneto = false;
  public isGas = false;
  public isModalOpen2 = false;
  public day = "";
  public month = "";
  public year = "";
  public day2 = "";
  public month2 = "";
  public year2 = "";
  public venetoForm: FormGroup;
  public notorietaForm: FormGroup;
  public venetoOptions = [
    {
      label: "Possiedo",
      value: "true"
    },
    {
      label: "Non possiedo",
      value: "false"
    }
  ];
  public notorietaOptions = [
    {
      label:
        "Che l'impianto gas, oggetto della richiesta di attivazione della fornitura a seguito di subentro, è stato modificato",
      value: NotorietaRadio.modificato,
      alert: ""
    },
    {
      label:
        "Che l'impianto gas, oggetto della richiesta di attivazione della fornitura a seguito di subentro, non è stato modificato e che è disponibile la documentazione attestante la sicurezza dell'impianto (dichiarazione di conformità o di rispondenza, ai sensi della Legge 46/90 o del D.M. 37/08, oppure scheda di verifica dei requisiti di sicurezza, di cui all'all. II del D.M. 26/11/98)",
      value: NotorietaRadio.non_modificato,
      alert: ""
    },
    {
      label:
        "Che l'impianto gas, oggetto della richiesta di attivazione della fornitura ad uso esclusivamente tecnologico (artigianale-industriale), è stato costruito nel rispetto della normativa antincendio",
      value: NotorietaRadio.tecnologico,
      alert: "(Non selezionabile per le forniture ad uso domestico)"
    }
  ];
  public venetoProvinces = ["BL", "PD", "RO", "TV", "VE", "VR", "VI"];

  constructor(private api: AlgAttivazioniService) {
    //
  }

  ngOnInit() {
    this.api.attivazione$
      .pipe(
        tap(attivazione => {
          //
        })
      )
      .subscribe(attivazione => {
        this.attivazione = attivazione;
        // impostare il veneto e il gas qui
        if (this.venetoProvinces.indexOf(this.attivazione.province) > -1) {
          this.isVeneto = true;
          this.attivazione.venetoRadio = "false";
        } else {
          this.attivazione.venetoRadio = "";
        }
        if (attivazione.fornitureType != "Luce") {
          this.isGas = true;
        }
        if (this.attivazione.cadRadio1) {
          this.cadRadioValue = "cadRadio1";
        }
        if (this.attivazione.cadRadio2) {
          this.cadRadioValue = "cadRadio2";
        }
        if (this.attivazione.cadRadio3) {
          this.cadRadioValue = "cadRadio3";
        }
        if (this.attivazione.cadRadio4) {
          this.cadRadioValue = "cadRadio4";
        }
        if (this.attivazione.cadRadio5) {
          this.cadRadioValue = "cadRadio5";
        }
        if (this.attivazione.cadRadio6) {
          this.cadRadioValue = "cadRadio6";
        }
      });

    this.stepForm = new FormGroup({
      cadRadioOptions: new FormControl(this.cadRadioValue, {
        validators: [Validators.required]
      }),
      cadSection: new FormControl(this.attivazione.cadSection, {
        // validators: [Validators.required]
      }),
      cadSheet: new FormControl(this.attivazione.cadSheet, {}),
      cadMap: new FormControl(this.attivazione.cadMap, {}),
      cadSubaltern: new FormControl(this.attivazione.cadSubaltern, {})
    });

    // venetoForm
    this.venetoForm = new FormGroup({
      venetoCity: new FormControl(this.attivazione.venetoCity, {}),
      venetoRadio: new FormControl(this.attivazione.venetoRadio, {}),
      day: new FormControl(this.day, {}),
      month: new FormControl(this.month, {}),
      year: new FormControl(this.year, {}),
      day2: new FormControl(this.day, {}),
      month2: new FormControl(this.month, {}),
      year2: new FormControl(this.year, {})
    });

    // notorietaForm
    this.notorietaForm = new FormGroup({
      notorietaRadio: new FormControl(this.attivazione.notorietaRadio, {
        validators: [Validators.required]
      })
    });
  }

  checkDate() {
    if (this.year != "" && this.month != "" && this.day != "") {
      this.attivazione.venetoDate = `${this.month}/${this.day}/${this.year}`;
    }
    if (this.year2 != "" && this.month2 != "" && this.day2 != "") {
      this.attivazione.venetoStart = `${this.day2}/${this.month2}/${this.year2}`;
    }
  }

  public nextStep() {
    if (this.firstFormStatus === "VALID" && this.stepForm.status === "VALID") {
      this.attivazione.titleRadio1 = false;
      this.attivazione.titleRadio2 = false;
      this.attivazione.titleRadio3 = false;
      this.attivazione.titleRadio4 = false;
      this.attivazione[this.firstFormRadioValue] = true;

      this.attivazione.cadRadio1 = false;
      this.attivazione.cadRadio2 = false;
      this.attivazione.cadRadio3 = false;
      this.attivazione.cadRadio4 = false;
      this.attivazione.cadRadio5 = false;
      this.attivazione.cadRadio6 = false;
      this.attivazione[this.cadRadioValue] = true;

      if ((this.isVeneto || this.isGas) && !this.isModalOpen2) {
        this.isModalOpen2 = true;
      } else {
        if (this.isGas && !(this.notorietaForm.status === "VALID")) {
          //
        } else {
          this.isModalOpen2 = false;
          if (!this.isModalOpen) {
            this.isModalOpen = true;
            window.setTimeout(() => {
              this.isModalOpen = false;
              this.api.nextStep(this.attivazione, Status.step1);
            }, 5000);
          }
        }
      }
    }

    // if (this.stepForm.status === 'VALID') {
    //   this.attivazione.cadRadio1 = false;
    //   this.attivazione.cadRadio2 = false;
    //   this.attivazione.cadRadio3 = false;
    //   this.attivazione.cadRadio4 = false;
    //   this.attivazione.cadRadio5 = false;
    //   this.attivazione.cadRadio6 = false;
    //   this.attivazione[this.cadRadioValue] = true;

    //   if (!this.isModalOpen){
    //     this.isModalOpen = true;
    //     window.setTimeout(()=>{
    //       this.isModalOpen = false;
    //       this.api.nextStep(this.attivazione, Status.step2);
    //     }, 5000)
    //   }
    // }
  }
}



// WEBPACK FOOTER //
// ./src/app/components/alg-attivazioni/alg-attivazioni-step2/alg-attivazioni-step2.component.ts